import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/videos';

interface RelatedVideosProps {
  currentId: number;
  category: string;
}

export default function RelatedVideos({ currentId, category }: RelatedVideosProps) {
  const related = videos
    .filter((v) => v.id !== currentId && v.category === category)
    .slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-links-line text-accent-600 text-sm"></i>
              </span>
              <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">Related</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              相关推荐
            </h2>
          </div>
          <Link
            to={`/category/${category}`}
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {related.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}